import { render, staticRenderFns } from "./scan&go.vue?vue&type=template&id=4a96200a&scoped=true"
import script from "./scan&go.vue?vue&type=script&lang=js"
export * from "./scan&go.vue?vue&type=script&lang=js"
import style0 from "./scan&go.vue?vue&type=style&index=0&id=4a96200a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96200a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a96200a')) {
      api.createRecord('4a96200a', component.options)
    } else {
      api.reload('4a96200a', component.options)
    }
    module.hot.accept("./scan&go.vue?vue&type=template&id=4a96200a&scoped=true", function () {
      api.rerender('4a96200a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/scan&go.vue"
export default component.exports